import React from 'react';
import { cn } from '@/utils/cn';

export interface ChipProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Toggled-on state (filter applied, option chosen). Exposed to assistive tech as aria-pressed. */
  selected?: boolean;
  children: React.ReactNode;
}

/** Pill toggle for filters and option sets. For read-only status labels use <Badge> instead. */
export const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  ({ selected = false, className, type = 'button', children, ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      aria-pressed={selected}
      className={cn(
        'inline-flex select-none items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium touch-manipulation',
        'transition-colors duration-150 focus-ring disabled:pointer-events-none disabled:opacity-50',
        selected
          ? 'border-accent/40 bg-accent-soft text-accent-text'
          : 'border-ui-border bg-transparent text-ui-text2 hover:bg-ui-hover hover:text-ui-text',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);
Chip.displayName = 'Chip';
